import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-card border-t border-border py-12 pb-24 md:pb-12" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-gold" />
              </div>
              <span className="font-display text-xl text-foreground">{t('library.title')}</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="font-bold text-foreground text-sm mb-3">{t('footer.discover')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground transition-colors" title="Alle verhalen">{t('footer.library')}</Link></li>
              <li><Link to="/top" className="hover:text-foreground transition-colors" title="Populairste slaapverhalen">{t('footer.top_stories')}</Link></li>
              <li><Link to="/omas" className="hover:text-foreground transition-colors" title="Onze verhalenvertellers">Onze Oma's</Link></li>
              <li><Link to="/subscription" className="hover:text-foreground transition-colors" title="Premium abonnement €2,99">{t('footer.premium')}</Link></li>
              <li><Link to="/gift" className="hover:text-foreground transition-colors" title="Cadeau-abonnement">Cadeaubon</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-foreground text-sm mb-3">{t('footer.participate')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/login" className="hover:text-foreground transition-colors">{t('footer.login')}</Link></li>
              <li><Link to="/login" className="hover:text-foreground transition-colors">{t('footer.register')}</Link></li>
              <li><Link to="/upload" className="hover:text-foreground transition-colors">{t('footer.upload')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-foreground text-sm mb-3">{t('footer.info')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">{t('footer.terms')}</Link></li>
              <li><span className="cursor-default">{t('footer.contact')}</span></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t border-border flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <p className="flex items-center gap-1">
            {t('footer.made_with')} <Heart className="w-3.5 h-3.5 text-old-rose fill-old-rose" /> {t('footer.in_nl')}
          </p>
          <p>&copy; {new Date().getFullYear()} {t('library.title')}. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
